module.exports = __webpack_public_path__ + "b921aeaf57811af3d52d7d7204f4ead8.svg";